'use strict';

import validator from '../../validator';
import analytics from '../../analytics';
import shipping from './shipping';
import inputField from '../../input-field';
import util from '../../util';

// google autocomplete dropdown
function loadGoogleAutocompleteData(element) {
	var $element = element; // element param accepts jquery input selector e.g. $(this)
    var $country = $element.length && $element.closest('form').find('.input-text.country + input[name$="_country"], .input-select.country');	
    // generate autocomplete dropdown 
	var $autoCompleteDropdown = $element.length ? $element.closest('.field-wrapper').find(".autocomplete-input-dropdown") : 0;	
	if($autoCompleteDropdown.length === 0 && $element.length) {
		$('<div class="autocomplete-input-dropdown google-autocomplete hide"><ul class="autocomplete-list"></</ul></div>').appendTo($element.closest('.field-wrapper'));
		$element.closest('.form-row').addClass('enabled-autocomplete');  
	}
	// populate autocomplete data when more than 4 char entered
	if($autoCompleteDropdown.length && ($element.length && $element.val().length > 4) && ($country.length && $country.val() !== null)){
		$.ajax({
			type: 'GET',
			url: Urls.googleAddressAPI,
			data: {
				'action': 1,
				'input': $element.val(),
				'components':'country:' + $country.val()
			},
			success: function (response) {
				var result = response.result;	
				if(response.status === '200' && result.length){
					$autoCompleteDropdown.removeClass("hide").find(".autocomplete-list").empty();					
					if(result.length && $element.val().length > 4) {
						$.each(result, function(index, item){
							$('<li class="autocomplete-list-item" data-place-id="'+ item.place_id +'">'+ '<i class="icon-location"></i><span class="list-item-text">'+ item.description +'</span></li>').appendTo($element.closest('.field-wrapper').find(".autocomplete-list"));
						});
					} else {
						$autoCompleteDropdown.addClass('hide').find(".autocomplete-list").empty();	
					}
				}	
			},
			error: function () {
				console.error('something went wrong while fetching data!');
			}
		})	
	} else {
		$autoCompleteDropdown.addClass('hide').find(".autocomplete-list").empty();	
	}
}

// select option from google autocompleted dropdown 
function selectGoogleAutocompleteOption(){
	$(document).off('click', '.google-autocomplete .autocomplete-list-item');// to stop event bubbling	
	$(document).on('click', '.google-autocomplete .autocomplete-list-item', function(e) {
		e.preventDefault();
        var _that = $(this);
		if(_that.data('place-id').length) {
			$.ajax({
				type: 'GET',
				url: Urls.googleAddressAPI,
				data: {
					'action': 2,
					'place_id': _that.data('place-id')
				},
				success: function (response) {
                    var result = response.result;
                    var $form = _that.closest('form'),
                        $addressField1 = $form.find('input[name$="_address1"]'),
                        $addressField2 = $form.find('input[name$="_address2"]'),
                        $cityField = $form.find('input[name$="_city"]'),
                        $postalField = $form.find('input[name$="_postal"]');

                    if(response.status === '200' && Object.keys(result).length !== 0){
                        // assign value to input fields
                        (Boolean(result.addressOne)) ? $addressField1.val(result.addressOne) : $addressField1.val('');
                        (Boolean(result.addressTwo)) ? $addressField2.val(result.addressTwo) : $addressField2.val('');
                        (Boolean(result.city)) ? $cityField.val(result.city) : $cityField.val('');
                        (Boolean(result.postal_code)) ? $postalField.val(result.postal_code) : $postalField.val('');

						// to hide dropdown
                        _that.closest('.google-autocomplete').addClass('hide');

						// to validate field's data
						$addressField1.trigger('focusout');
						$cityField.trigger('focusout');
						$postalField.trigger('focusout');
						if ($form.hasClass('shipping-address-section')) {
							$form.find('.shipping-address-section input[name$="_address1"]').trigger('focusout');
							$form.find('.shipping-address-section input[name$="_city"]').trigger('focusout');
							$form.find('.shipping-address-section input[name$="_postal"]').trigger('focusout');

						}
						//google analytics
						analytics.googleAddressTracking();
						shipping.updateShippingMethodList();
						inputField.setEditMaterialFields();
						setTimeout(() => {
							util.limitCharacters();
						}, 2500);
                    }
				},
				error: function () {
					console.error('something went wrong while fetching data!');
				}
			})
		}	
	});
}

// to init DOM events
function initEvents() {
    // to bind google address autocomplete on keyevents	
	$('form[id$="_shippingAddress"]').on('keyup', 'input[name$="_address1"]', function(){
		!$(this).is(":-webkit-autofill") && loadGoogleAutocompleteData($(this));

	});

    $('form[id$="EditAddressForm"]').on('keyup', 'input[name$="_address1"]', function(){
		!$(this).is(":-webkit-autofill") && loadGoogleAutocompleteData($(this));

	});

    // to bind click event on google autocomplete dropdown
	selectGoogleAutocompleteOption();

    // close google autocomplete dropdown on outside click
    $(document).on('mouseup', '.pt_checkout, .pt_account, .reveal', function(e) {
        var container = $(".autocomplete-input-dropdown.google-autocomplete");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.addClass('hide');
        }
    });
}

export default {
    init: function () {
        initEvents();
    }
};